var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.slider.length > 0)?_c('slider',{attrs:{"list":_vm.slider}}):_vm._e(),_c('welcome'),_c('products'),(_vm.lastwork.length > 0)?_c('say',{attrs:{"list":_vm.lastwork}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }